import React, {
    useState
}
from "react";



//========================================================
// Snippet Search Result
//========================================================

export default function SnippetSearchResult({

    result,

    onInspect

})
{
	
	console.log(
	    "SNIPPET SEARCH RESULT",
	    result
	);

    const [expanded, setExpanded] =
        useState(false);


    //====================================================
    // Content
    //====================================================

    const contentType =
        (
            result.contentType ||
            "TEXT"
        ).toUpperCase();

    const isText =
        contentType === "TEXT";

    const contentTypeLabel =
        getContentTypeLabel(
            contentType
        );

    const contentTypeDescription =
        getContentTypeDescription(
            contentType
        );


    //====================================================
    // Toggle Expanded
    //====================================================

    function toggleExpanded(event)
    {

        event.stopPropagation();

        setExpanded(
            current => !current
        );

    }


    //====================================================
    // Render
    //====================================================

    return (

        <div
            style={styles.container}
            onClick={
                () => onInspect(result)
            }
        >

            {/*============================================
                Header
            ============================================*/}

            <div style={styles.header}>

                <div style={styles.document}>

                    {
                        result.documentTitle ||
                        "Untitled Document"
                    }

                </div>

                <div style={styles.page}>

                    Page {result.pageNumber}

                </div>

            </div>


            {/*============================================
                Content Type
            ============================================*/}

            {
                !isText &&

                <div style={styles.contentTypeRow}>

                    <span style={styles.contentTypeBadge}>

                        {contentTypeLabel}

                    </span>

                    <span style={styles.contentTypeDescription}>

                        {contentTypeDescription}

                    </span>

                </div>
            }


            {/*============================================
                Summary
            ============================================*/}

            <div style={styles.summary}>

                {
                    result.summary ||
                    "No summary is available for this page."
                }

            </div>


            {/*============================================
                Expanded Text
            ============================================*/}

            {
                isText &&
                expanded &&

                <div
                    style={styles.extractedContent}
                    onClick={
                        event =>
                            event.stopPropagation()
                    }
                >

                    <div style={styles.extractedTitle}>

                        FULL PAGE TEXT

                    </div>

                    <div style={styles.extractedText}>

                        {
                            result.snippet ||
                            "No extracted text is available for this page."
                        }

                    </div>

                </div>
            }


            {/*============================================
                Footer
            ============================================*/}

            <div style={styles.footer}>

                <div>

                    {
                        isText &&

                        <button
                            type="button"
                            style={styles.actionButton}
                            onClick={toggleExpanded}
                        >

                            {
                                expanded
                                    ? "Hide full text ↑"
                                    : "Show full text ↓"
                            }

                        </button>
                    }

                </div>

                <div style={styles.inspectAction}>

                    Inspect page →

                </div>

            </div>

        </div>

    );

}



//========================================================
// Content Type Label
//========================================================

function getContentTypeLabel(
    contentType
)
{

    switch (contentType)
    {

        case "TABULAR":

            return "Tabular data";


        case "IMAGE":

            return "Image content";


        case "DRAWING":

            return "Drawing content";


        case "MIXED":

            return "Mixed content";


        case "COMPLEX":

            return "Complex content";


        default:

            return contentType;

    }

}



//========================================================
// Content Type Description
//========================================================

function getContentTypeDescription(
    contentType
)
{

    switch (contentType)
    {

        case "TABULAR":

            return (
                "Structured data — inspect the original " +
                "page to preserve layout."
            );


        case "IMAGE":

            return (
                "Visual content — inspect the original " +
                "page to preserve context."
            );


        case "DRAWING":

            return (
                "Graphical content — inspect the original " +
                "page to preserve layout."
            );


        case "MIXED":

            return (
                "Text and structured or visual content — " +
                "inspect the original page."
            );


        case "COMPLEX":

            return (
                "Complex page structure — inspect the " +
                "original page."
            );


        default:

            return "";

    }

}



//========================================================
// Styles
//========================================================

const styles =
{

    container:
    {
        background:
            "rgba(255,255,255,0.97)",

        border:
            "1px solid rgba(38,55,70,0.10)",

        borderRadius: "8px",

        padding: "18px 20px",

        marginBottom: "10px",

        boxShadow:
            "0 5px 18px rgba(38,55,70,0.06)",

        cursor: "pointer"
    },

    header:
    {
        display: "flex",

        justifyContent: "space-between",

        alignItems: "center",

        gap: "20px",

        marginBottom: "10px"
    },

    document:
    {
        fontSize: "14px",

        fontWeight: 600,

        color: "#263746",

        overflow: "hidden",

        textOverflow: "ellipsis",

        whiteSpace: "nowrap"
    },

    page:
    {
        flexShrink: 0,

        fontSize: "12px",

        color: "#7b8791"
    },

    contentTypeRow:
    {
        display: "flex",

        alignItems: "center",

        gap: "10px",

        marginBottom: "10px"
    },

    contentTypeBadge:
    {
        display: "inline-flex",

        flexShrink: 0,

        alignItems: "center",

        padding: "4px 8px",

        borderRadius: "4px",

        background:
            "rgba(38,55,70,0.07)",

        fontSize: "10px",

        fontWeight: 700,

        letterSpacing: "0.6px",

        textTransform: "uppercase",

        color: "#263746"
    },

    contentTypeDescription:
    {
        fontSize: "11px",

        color: "#8a959e"
    },

    summary:
    {
        fontSize: "14px",

        lineHeight: "1.6",

        color: "#52616d"
    },

    extractedContent:
    {
        marginTop: "14px",

        padding: "14px",

        background:
            "rgba(38,55,70,0.035)",

        border:
            "1px solid rgba(38,55,70,0.08)",

        borderRadius: "6px",

        cursor: "default"
    },

    extractedTitle:
    {
        marginBottom: "8px",

        fontSize: "9px",

        fontWeight: 700,

        letterSpacing: "1.2px",

        color: "#8a959e"
    },

    extractedText:
    {
        maxHeight: "280px",

        overflowY: "auto",

        whiteSpace: "pre-wrap",

        fontSize: "12px",

        lineHeight: "1.6",

        color: "#667580"
    },

    footer:
    {
        display: "flex",

        justifyContent: "space-between",

        alignItems: "center",

        minHeight: "18px",

        marginTop: "14px"
    },

    actionButton:
    {
        padding: 0,

        border: "none",

        background: "transparent",

        fontFamily: "inherit",

        fontSize: "12px",

        fontWeight: 600,

        color: "#607d8b",

        cursor: "pointer"
    },

    inspectAction:
    {
        fontSize: "12px",

        fontWeight: 600,

        color: "#607d8b"
    }

};